export const CONTACTMETHODS = {
    EMAIL: 'email',
    TEXT: 'text',
    EMAIL_TEXT: 'email,text'
};